import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	manualReceiveEditContainer: {
		width: "100%",
		maxWidth: "100%",
		overflow: "hidden",
		marginBottom: 100,
	},
	previousReceiveHeaderContainer: {
		textAlign: "center",
		margin: "auto",
	},
	offset: {
		marginLeft: "12px",
		marginRight: "12px",
		marginBottom: "20px",
		overflow: "hidden",
	},
	receiveHeaderRow: {
		minHeight: "80px",
	},
	receiveHeaderRowValues: {
		minHeight: "30px"
	},
	editIcon: {
		marginTop: "-8px",
	},
	previousReceiveListContainer: {
		backgroundColor: theme.palette.background.paper,
	},
	noPadding: {
		padding: 0,
	},
	mainGrid: {
		marginBottom: "20px",
	},
}));
